import { CohortMemberStatus, CohortStatus } from "generated-graphql/graphql";
import { useMemo } from "react";

import { WorkflowPayments } from "../../../../components/Payment/ReportPayments";
import { useCohortDetails } from "../useCohortDetails";

export function Payments() {
  const { data } = useCohortDetails();

  const cohort = data?.cohort;
  const activities = useMemo(
    () => cohort?.currentWorkflow?.activities || [],
    [cohort?.currentWorkflow?.activities]
  );

  // Extract report IDs from READY cohort members for auto-populating payments
  const readyMemberReportIds = useMemo(
    () =>
      cohort?.members
        ?.filter((m) => m.status === CohortMemberStatus.Ready && m.tierIIReportId)
        .map((m) => m.tierIIReportId!) ?? [],
    [cohort?.members]
  );

  // Only allow payment creation for closed cohorts
  const isCohortClosed = cohort?.status === CohortStatus.Closed;

  if (!cohort) {
    return null;
  }

  return (
    <WorkflowPayments
      activities={activities}
      tenantId={cohort.tenantId}
      cohortMode={true}
      showPaper={true}
      title="Payments"
      showActions={false}
      showCreateButton={isCohortClosed}
      disabledButtonTooltip={
        !isCohortClosed ? "Payments can only be created for closed cohorts" : undefined
      }
      cohortMemberReportIds={readyMemberReportIds}
    />
  );
}
